// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"d5951cd2","231":"8e684fb6","381":"7362c6c5","522":"3b53517f","539":"43e189e0","631":"f265eb68"}[chunkId] + ".chunk.css";
};